// Your web app's Firebase configuration
export default {
  apiKey: "AIzaSyCNKQsbWqIwVLeilgbFgALUew8yyBcvuV0",
  authDomain: "beenokle-cdp.firebaseapp.com",
  projectId: "beenokle-cdp",
  storageBucket: "beenokle-cdp.appspot.com",
  messagingSenderId: "860486352834",
  appId: "1:860486352834:web:0799534d552527e280205b"
};